import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import { Redirect } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  APIHandler,
  DataHandler,
  StorageHandler,
  LinkButton,
} from 'C4';

import { appContentUrl, storageKeys } from 'settings';

import RetainContent from './RetainContent';


import Sidebar from './Sidebar';

const verify = () => (
  StorageHandler.load(storageKeys.user)
    .then((user) => {
      if (!user) return <Redirect to="/login" />;
      return StorageHandler.load(storageKeys.chapters)
        .then((chapters) => {
          if (!chapters) return <Redirect to="/main/retain" />;
          return { value: true, chapters };
        });
    })
);

export default class RetainContentView extends Component {
  constructor(props) {
    super(props);

    const { pageId } = this.props.match.params;

    this.state = {
      appId: -1,
      verified: false,
      chapters: null,
      pages: null,
      items: [],
      targetSwitch: +pageId,
      buttons: [],
    };

    this.switchPage = this.switchPage.bind(this);
  }

  componentWillMount() {
    DataHandler.matchAppId()
      .then((appId) => {
        verify()
          .then((verified) => {
            const { value, chapters } = verified;
            this.setState({ appId, verified: (value || verified), chapters: (chapters || null) });
            this.setList();
          });
      });
  }

  componentDidMount() {
    document.querySelector('html').addEventListener('keydown', this.switchPage);
  }

  componentDidUpdate() {
    const { verified } = this.state;
    if (!verified) {
      this.setList();
    }
  }

  componentWillUnmount() {
    document.querySelector('html').removeEventListener('keydown', this.switchPage);
  }

  getPages() {
    const { chapterId } = this.props.match.params;
    return StorageHandler.load(storageKeys.pages)
      .then((localPages) => {
        if (localPages) {
          const [final] = localPages.filter(page => page.upID !== undefined);
          if (final && final.upID.indexOf(chapterId) === 0) return localPages;
        }
        return APIHandler.getTrainingPages(chapterId)
          .then((pages) => {
            StorageHandler.save(storageKeys.pages, pages);
            return pages;
          });
      });
  }

  setList() {
    const { chapterId, pageId } = this.props.match.params;
    const { history } = this.props;
    this.getPages()
      .then((pages) => {
        const filteredPages = pages.filter(page => page.pageType !== undefined && page.pageType !== 'Final-Page');
        const items = filteredPages.map((page, i) => ({
          name: (page.title || page.pageType),
          type: page.pageType,
          active: i === +pageId,
          onClick: () => {
            this.setState({ verified: false });
            history.push(`/main/ret/chapter/${chapterId}/${i}`);
          },
        }));
        this.setButtons(filteredPages[+pageId]);
        this.setState({ verified: true, items, pages: filteredPages });
      });
  }

  setButtons(page) {
    const buttons = [];
    this.setState({ buttons });
    let index = 1;

    if (page !== undefined) {
      index = 1;
      Object.keys(page).forEach((link) => {
        const links = [page[`link${index}`], page[`linkType${index}`]].every(val => (val !== undefined && val.length > 0));
        const linksValid = (page.question === undefined && links);
        if (link === `link${index}` && linksValid) {
          buttons.push(<LinkButton
            key={page[`linkType${index}`]}
            link={page[`link${index}`]}
            type={page[`linkType${index}`]}
          />);
          index += 1;
        }
      });
      this.setState({ buttons });
    }
  }

  switchPage(e) {
    const { history, match } = this.props;
    const { pageId, chapterId } = match.params;
    const { pages } = this.state;
    if (e.key === 'ArrowDown' && +pageId < pages.length - 1) {
      e.preventDefault();
      this.setState({ verified: false });
      history.push(`/main/ret/chapter/${chapterId}/${+pageId + 1}`);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.setState({ verified: false });
      history.push(`/main/ret/chapter/${chapterId}/0`);
    }
    if (e.key === 'ArrowUp' && +pageId > 0) {
      e.preventDefault();
      this.setState({ verified: false });
      history.push(`/main/ret/chapter/${chapterId}/${+pageId - 1}`);
    } else if (e.key === 'ArrowUp' && +pageId === 0) {
      e.preventDefault();
      this.setState({ verified: false });
      history.push(`/main/ret/chapter/${chapterId}/${pages.length - 1}`);
    }
  }

  verifyUrl() {
    const { url, params } = this.props.match;
    const { pageId, chapterId } = params;
    const { chapters, pages } = this.state;
    if (chapters && pages) {
      return ((chapters.app.some(chapter => +chapter.chapterID === +chapterId) && (+pageId >= 0 && +pageId < pages.length))
        ? null
        : <Redirect to={url.substring(0, url.indexOf(chapterId))} />);
    }
    return null;
  }

  render() {
    const { chapterId, pageId } = this.props.match.params;
    const {
      appId, verified, items, pages, chapters, buttons,
    } = this.state;

    return (
      <section className="retain container">
        {verified !== true ? verified : null}
        {items &&
        chapters &&
          <Sidebar
            appId={appId}
            items={items}
            image={chapters.app.filter(chapter => +chapter.chapterID === +chapterId)[0].chapterImage}
          />}
        {pages !== null &&
          <RetainContent
            appId={appId}
            image={`${appContentUrl}${appId}/${pages[pageId].image}`}
            summary={{
              title: pages[pageId].title,
              text: renderHTML(pages[pageId].summary || ''),
            }}
            params={pages[pageId]}
            buttons={buttons}
            upID={pages[pageId].upID}
          />}
        {this.verifyUrl()}
      </section>
    );
  }
}

RetainContentView.propTypes = {
  match: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
};
